"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPaymentDataCreditCardBrandEnum = exports.StoredPaymentDataCreditCardToJSON = exports.StoredPaymentDataCreditCardFromJSONTyped = exports.StoredPaymentDataCreditCardFromJSON = void 0;
function StoredPaymentDataCreditCardFromJSON(json) {
    return StoredPaymentDataCreditCardFromJSONTyped(json, false);
}
exports.StoredPaymentDataCreditCardFromJSON = StoredPaymentDataCreditCardFromJSON;
function StoredPaymentDataCreditCardFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': json['number'],
        'brand': json['brand'],
        'validThru': json['validThru'],
    };
}
exports.StoredPaymentDataCreditCardFromJSONTyped = StoredPaymentDataCreditCardFromJSONTyped;
function StoredPaymentDataCreditCardToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'number': value.number,
        'brand': value.brand,
        'validThru': value.validThru,
    };
}
exports.StoredPaymentDataCreditCardToJSON = StoredPaymentDataCreditCardToJSON;
/**
* @export
* @enum {string}
*/
var StoredPaymentDataCreditCardBrandEnum;
(function (StoredPaymentDataCreditCardBrandEnum) {
    StoredPaymentDataCreditCardBrandEnum["VISA"] = "VISA";
    StoredPaymentDataCreditCardBrandEnum["MASTERCARD"] = "MASTERCARD";
    StoredPaymentDataCreditCardBrandEnum["AMERICANEXPRESS"] = "AMERICAN_EXPRESS";
    StoredPaymentDataCreditCardBrandEnum["DINERS"] = "DINERS";
    StoredPaymentDataCreditCardBrandEnum["DISCOVER"] = "DISCOVER";
})(StoredPaymentDataCreditCardBrandEnum = exports.StoredPaymentDataCreditCardBrandEnum || (exports.StoredPaymentDataCreditCardBrandEnum = {}));
//# sourceMappingURL=StoredPaymentDataCreditCard.js.map